import React, { useMemo } from "react"

import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { Customer } from "pages/vendor/Customers/CustomersBundles"
import { useTranslation } from "react-i18next"

interface CustomerBundelsTable {
  customers: Customer[]
  isAllChecked: boolean
  checkedCustomers: Customer[]
  toggleAllCustomers: () => void
  toggleActiveCustomer: (customer: Customer) => void
  togglecheckedCustomerHandler: (customer: Customer) => void
  location?: any
}

const CustomerBundelsTable: React.FC<CustomerBundelsTable> = ({
  customers,
  checkedCustomers,
  isAllChecked,
  toggleActiveCustomer,
  togglecheckedCustomerHandler,
  toggleAllCustomers,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllCustomers}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Customer } }) => {
          return (
            <input
              onClick={() =>
                togglecheckedCustomerHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedCustomers.find(c => c.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("customers_customerName"),
        accessor: "customerName",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return (
            <div className="d-flex flex-column align-items-statrt">
              <p className="mb-0">{cellProps.row.original.customerName}</p>
              <p className="mb-0">{cellProps.row.original.id}</p>
            </div>
          )
        },
      },
      {
        Header: t("customers_couponConsumptionRate"),
        accessor: "couponConsumptionRate",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return <>{cellProps.row.original.couponConsumptionRate}</>
        },
      },
      {
        Header: t("customers_areas"),
        accessor: "area",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return <>{cellProps.row.original.area}</>
        },
      },
      {
        Header: t("customers_preferredPerWeek"),
        accessor: "preferredPerWeek",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return <>{cellProps.row.original.preferredPerWeek}</>
        },
      },
      {
        Header: t("customers_received"),
        accessor: "received",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return <>{cellProps.row.original.received}</>
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Customer } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.status === "Active"}
                onClick={() => toggleActiveCustomer(cellProps.row.original)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.status}
              </label>
            </div>
          )
        },
      },
    ],
    [customers, t, checkedCustomers]
  )

  return (
    <TableContainer
      columns={columns}
      data={customers}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

CustomerBundelsTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CustomerBundelsTable))
